import { gql } from '@apollo/client'

export const SELECTIONS_QUERY = gql`
  query columnSelections($shared: Boolean, $pool: String) {
    columnSelections(shared: $shared, pool: $pool) {
      collection {
        id
        title
        columns
        sharedWith
        user {
          name
        }
      }
    }
  }
`
